import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import  api from '../common/api';
import  MediaFile from '../common/MediaFile';
import LinearProgress from '@material-ui/core/LinearProgress';

class VehiclesImport extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
          loaded: false,
          dialogOpen: false,
          contract:{name:''},
          contract_id:0,
          is_update:0,
		  is_ac_car: 0,
          need_hansa_update:1,
		  saving: false,
		  menu:{open: false},
          files:[]
		}
  	}

  	componentDidMount(){
  		var contract_id = this.props.match.params.contract_id
  		var is_update = this.props.match.params.is_update
  		var is_ac_car = this.props.match.params.is_ac_car
  		var need_hansa_update = this.props.match.params.need_hansa_update
  		is_update = (is_update) ? is_update : 0 
  		need_hansa_update = (need_hansa_update) ? need_hansa_update : 0 
  		this.setState({contract_id, is_update, need_hansa_update})
  		if (contract_id !== "0"){
		    this.getContract(contract_id)
  		} 
		if (is_ac_car === '1'){
			this.setState({contract: {name: "AutoCorp"},is_ac_car: 1})
		}

  	}

  	handleDownloadTemplate = (type) => {
  		if(this.state.contract_id === "0"){
			if (type === 'full')
            	window.location.href = api.vehicle_update_template
			if (type === 'duedates')
            	window.location.href = api.vehicle_duedates_update_template
  		} else {
  			window.location.href = api.vehicle_import_template
  		}
		this.handleMenuClose();
  	}

	handleMenuClose = (e) => {
		var menu = this.state.menu
		menu.open = !menu.open
		menu.anchorEl = (e) ? e.currentTarget : menu.anchorEl
		this.setState({menu})
	}

	handleUploadFile = (file, meta_data) => {
		var files_state = this.state.files
		var file = {file: file, meta_data: meta_data}
		files_state.push(file)
		this.setState({files: files_state})
	}	

	handleSubmit = (e) => {
		this.setState({saving: true})
    	e.preventDefault();
	    var formData = new FormData();
		var i = 0;
		if (this.state.files){
			this.state.files.map((val, idx) => {
				if (val.file !== '' && val.file !== undefined){
					formData.set("import", val.file[0])
					i++;
				}	
			})
		}
	    formData.set("contract_id", this.state.contract_id);
	    formData.set("is_update", this.state.is_update);
		formData.set("need_hansa_update", this.state.need_hansa_update)
		formData.set("is_ac_car", this.state.is_ac_car)
	    var errors =[]
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.post(api.vehicles().import(0),
	       formData,
	       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
	       )
	      .then((response)=> {
		  		this.setState({excel_loaded:true, message: response.data.message, saving: false })
	      })
	      .catch(function (error) {
				var promise = new Promise(function(resolve, reject) {
					resolve(error.response.data);
					errors = error.response.data
		  		});
				self.setState({errors:errors, files:[], excel_loaded:true, saving: false})		  		

	    })
	}

  	getContract(contract_id){
	    const token = localStorage.getItem('userToken')
	    var results =  axios
	        .all([
	              axios.get(api.contract().get(contract_id),{ headers: {"Authorization" : `Bearer ${token}`} }),
	        ])
	        .then(
	        axios.spread((...responses) => {
	          const contract = responses[0].data[0];
	              this.setState({
	                  contract,
	                  loaded:true
	              })
	            }))
  	}


  	render(){
		
	    const handleRedirect = id => () => {
	      window.location.href='/vehicles'
	    }
	    var errors = []
	    if (this.state.errors){
	    	var messages = Object.values(this.state.errors.message)
      		messages.map((val,idx)=>{
      			var rows = Object.keys(val)
      			rows.map((val2,idx2)=>{
	      			var fields = Object.values(val[val2])
	      			fields.map((val3,idx3)=>{
	      				var message = 'La linea ' + val2 + ': '+val3[0]
	      				errors.push(message)
	      				/*return (
	          				<div style={{color: 'red'}}>Línea {row}: {val2[0]}</div>
	  					)*/
	      			})

      			})

      		})
	    }
  		return(
	         <Container fluid className="main-content-container px-4 pb-4">
	            <Row noGutters className="page-header pt-4">
	              <PageTitle lg="12" title={(this.state.contract_id === "0" && !this.state.is_ac_car ) ? "Actualizacion masiva" : "Alta masiva de "+this.state.contract.name} className="text-lg-left" />
	            </Row>
				<Row>
				<Col md="12">
				  <React.Fragment>
			      <div className="mt-2">
	              {(this.state.loading)?
	                 <LinearProgress /> 
	              :
	              	(this.state.excel_loaded)
	              	?
		              	(this.state.errors) ?
		              		errors.map((val,idx2)=>{
		              			return (
		              				<div className="mt-1">{val}</div>
		          				)
		              		})
		              	:
		              	<div>{this.state.message}</div>
		            :
						<React.Fragment>
							<MediaFile onChange={this.handleUploadFile} title="Agregar excel" width={"15rem"} height={"2rem"}  meta_data="comprobante" />
							<Button disabled={(this.state.saving === true) ? true : false} className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={this.handleSubmit}>Cargar</Button>
						</React.Fragment>
				  }			  

				{ (parseInt(this.state.is_update) === 0) && <Button disabled={(this.state.saving === true) ? true : false} className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {this.handleDownloadTemplate('full')}}>Descargar Template</Button>}
				{ (parseInt(this.state.is_update) === 1) && <>
					<Button disabled={(this.state.saving === true) ? true : false} className="mt-2 mr-2" variant="contained" color="primary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {this.handleMenuClose(e)}}>Descargar Template</Button>				
					<Menu
						id="download-menu"
						MenuListProps={{
							'aria-labelledby': 'download-button',
						}}
						anchorEl={this.state.menu.anchorEl}
						open={this.state.menu.open}
						onClose={(e) => {this.handleMenuClose(e)}}
					>
					<MenuItem onClick={(e) => {this.handleDownloadTemplate('full')}}>Completo</MenuItem>
					<MenuItem onClick={(e) => {this.handleDownloadTemplate('duedates')}}>Vencimientos</MenuItem>
				</Menu></>}
				<Button disabled={(this.state.saving === true) ? true : false} className="mt-2" variant="contained" color="secondary" size="small" style={{fontSize: '0.75rem'}} onClick={(e) => {window.location.href='/vehicles'}}>Volver</Button>
				</div>
	            </React.Fragment>
	          </Col>
	        </Row>
	      </Container>

		)
  	}

}
export default VehiclesImport;
